export interface IScript {
  id: number;
  type: string;
  active: boolean;
  value: string;
}

export interface IChat {
  type: enChat | '';
  key: string;
  active: boolean;
  createdDate?: string;
  updatedDate?: string;
}

export enum enChat {
  JIVOCHAT = 'jivochat',
  ZOPIMCHAT = 'zopimchat',
  TAWKTOCHAT = 'tawktochat',
  ZENDESKCHAT = 'zendeskchat',
  LIVECHAT = 'livechat',
  CLICKDESK = 'clickdesk',
  WHATSAPP = 'whatsapp',
  WHATSAPPLINK = 'whatsapp-link'
}
